/* eslint-disable @typescript-eslint/no-unused-vars */
export const audienceCampaignSettingsStyles = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '& .crud-audience-campaign': {
    color: palette.neutralPrimary,
    padding: [0, 32],

    '& .description': {
      lineHeight: '24px',
      marginTop: 8,
    },

    '& .form-group': {

      '& .col-sm-2': {
        margin: [26, 0, 0, 0],
      },

      '& .Name-value': {
        padding: [6, 8, 7, 8],
        boxSizing: 'border-box',
        borderRadius: 2,
        width: 461,
        marginTop: 2,
        backgroundColor: palette.white,
      },

      '& .remaining-chars-hint': {
        marginBottom: 0,
        marginTop: 3,
      },

    },
  },
  '& .shopping-settings__container': {
    '& .col-sm-offset-2': {
      margin: 0,
    },

    '& .query-group-container': {
      border: `1px solid ${palette.neutralSecondary}`,
      padding: 10,
      width: 551,

      '& .query-editor': {
        margin: '2px 0',

        '& .form-control': {
          width: 188,
        },

        '& .text-center': {
          padding: '0 27px',
          width: 'auto',
        },

        '& .col-sm-5': {
          margin: 0,
          width: 'auto',
          padding: 0,
        },

        '& .control-label': {
          height: 32,
          lineHeight: '32px',
          margin: 0,
        },

        '& .remove-editor': {
          width: 'auto',
          padding: 0,
          margin: 0,
          marginLeft: 10,
          marginTop: 5,
        },
      },

      '& .col-sm-12': {
        float: 'none',
        padding: 0,
      },

      '& .text-right': {
        textAlign: 'left',
        marginTop: 15,
      },

      '& .addNewQuery': {
        '& .glyphicon ': {
          marginRight: 5,
          marginTop: '-5px',
        },
      },
    },

    '& .query-summary-item': {
      border: `1px solid ${palette.neutralSecondary}`,
      padding: 10,
      width: 462,

      '& div.query-item': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },

      '& .edit-query span': {
        verticalAlign: 'baseline',
      },
    },
  },
});
